import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
import { classNames } from "../../../utils";
export const ZoraLogo = t0 => {
  const $ = _c(20);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== className || $[7] !== fill) {
    t4 = classNames(fillVariants({
      fill
    }), className);
    $[6] = className;
    $[7] = fill;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== size) {
    t5 = {
      width: size,
      height: size
    };
    $[9] = size;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <radialGradient cx="65.351%" cy="24.357%" fx="65.351%" fy="24.357%" gradientTransform="matrix(1 0 0 .9635 0 .009)" id="zora-logo-circle-gradient-a" r="74.898%"><stop offset="0%" stopColor="#FFF" /><stop offset="45.833%" stopColor="#CCC" /><stop offset="65.625%" stopColor="#868686" /><stop offset="100%" stopColor="#4B4C3C" /></radialGradient>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <radialGradient cx="64.959%" cy="24.357%" fx="64.959%" fy="24.357%" gradientTransform="matrix(1 0 0 .9635 0 .009)" id="zora-logo-circle-gradient-b" r="75.291%"><stop offset=".521%" stopColor="#FFF" /><stop offset="45.833%" stopColor="#B6B6B6" /><stop offset="65.625%" stopColor="#929292" /><stop offset="100%" stopColor="#4B4C3C" /></radialGradient>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <defs>{t6}{t7}<radialGradient cx="64.959%" cy="24.357%" fx="64.959%" fy="24.357%" id="zora-logo-circle-gradient-c" r="75.291%"><stop offset="15.625%" stopColor="#CECECE" /><stop offset="30.208%" stopColor="#B0B0B0" /><stop offset="42.708%" stopColor="gray" /><stop offset="55.729%" stopColor="#5A5A5A" /><stop offset="79.688%" stopColor="#222" /><stop offset="90.625%" stopColor="#4B4B4B" /><stop offset="100%" stopColor="#202020" /></radialGradient></defs>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <g fill="none" fillRule="nonzero"><path d="M.809 11.79c0 6.501 5.094 11.789 11.358 11.789s11.359-5.288 11.359-11.79C23.52 5.288 18.426 0 12.167 0 5.903 0 .81 5.288.81 11.79Z" fill="url(#zora-logo-circle-gradient-a)" transform="translate(0 .975)" /><path d="M.809 11.79c0 6.501 5.094 11.789 11.358 11.789s11.359-5.288 11.359-11.79C23.52 5.288 18.426 0 12.167 0 5.903 0 .81 5.288.81 11.79Z" fill="url(#zora-logo-circle-gradient-b)" transform="translate(0 .975)" /><path d="M0 12c0 6.618 5.382 12 12 12s12-5.382 12-12c-.006-6.618-5.388-12-12-12C5.382 0 0 5.382 0 12Z" fill="url(#zora-logo-circle-gradient-c)" transform="translate(0 .975)" /></g>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== fillAttribute || $[16] !== rest || $[17] !== t4 || $[18] !== t5) {
    t10 = <svg className={t4} fill={fillAttribute} style={t5} viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" {...rest}>{t8}{t9}</svg>;
    $[15] = fillAttribute;
    $[16] = rest;
    $[17] = t4;
    $[18] = t5;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};